import React from 'react'
import reactStamp from 'react-stamp'
import Portal from '../components/Portal'
import Header from '../components/Header'

export default reactStamp(React).compose({

    init(){
        this.activateHome = this.activateHome.bind(this);
        this.activateHealth = this.activateHealth.bind(this);
        this.activateAppointments = this.activateAppointments.bind(this);
        this.activateDevices = this.activateDevices.bind(this);
        this.setName = this.setName.bind(this);
    },

    state: {
        active: 'Home',
        name: '',
        info: ''
    },

    render() {
        return (
            <div>
                <Header operations="" name={this.state.name}/>
                {this.getPortal()}
            </div>
        );
    },

    componentDidMount() {

    },

    getPortal(){
        return <Portal
            active={this.state.active}
            activateHome={this.activateHome}
            activateHealth={this.activateHealth}
            activateAppointments={this.activateAppointments}
            activateDevices={this.activateDevices}
            setName={this.setName}
        />
    },

    activateHome(){
        this.setState({active: 'Home'});
    },

    activateHealth(){
        this.setState({active: 'Health'});
    },

    activateAppointments(){
        this.setState({active: 'Appointments'});
    },

    activateDevices(){
        this.setState({active: 'Devices'});
    },
    
    setName(name){
        this.setState({name: name});
    }

});


/** WEBPACK FOOTER **
 ** ./src/app/containers/Portal.js
 **/